<template>
  <div class="pr-6" v-if="!isMobile()">
    <div class="my-6">
      <span class="main-title"
        >{{ user.name }}, veja como ficou a simulação!</span
      >
    </div>

    <div v-if="loading">
      <v-progress-circular
        class="ma-3"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>

    <div class="pa-4 user-infos mb-8" v-if="!loading">
      <v-row>
        <v-col cols="4" class="my-0">
          <strong class="title-label">Nome</strong>
          <br />
          <span class="label">{{ user.name }}</span>
        </v-col>
        <v-col cols="4" class="my-0">
          <strong class="title-label">CPF</strong>
          <br />
          <span class="label">{{ user.cpf }}</span>
        </v-col>
        <v-col cols="4" class="my-0">
          <strong class="title-label">Data de nascimento</strong>
          <br />
          <span class="label">{{ formatDate(user.dataNascimento) }}</span>
        </v-col>
        <v-col cols="4" class="my-0">
          <strong class="title-label">Número de filhos</strong>
          <br />
          <span class="label">{{ user.numeroFilhos }}</span>
        </v-col>
        <v-col cols="4" class="my-0">
          <strong class="title-label">Valor da renda mensal</strong>
          <br />
          <span class="label">
            {{
              user.valorRenda.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                style: "currency",
                currency: "BRL",
              })
            }}</span
          >
        </v-col>
      </v-row>
    </div>

    <span class="main-subtitle">Sua proteção escolhida:</span>

    <SelectedOption
      :number="selectedItem.number"
      :covers="selectedItem.covers"
      :key="selectedItem.number"
      :result="user"
    />

    <div class="my-6 d-flex justify-end align-center">
      <v-btn
        class="next-button"
        elevation="0"
        height="44"
        style="color: var(--custom-white-second-color)"
        width="161"
        @click="submit"
        :loading="loading"
      >
        <strong> Preencher proposta </strong>
      </v-btn>
    </div>
  </div>

  <div v-else>
    <div class="my-6">
      <span class="main-title">
        {{ user.name }}, veja como ficou a simulação!
      </span>
    </div>

    <div v-if="loading">
      <v-progress-circular
        class="ma-3"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>

    <div class="pa-4 user-infos mb-8 mr-6" v-if="!loading">
      <v-row>
        <v-col cols="6" class="my-0">
          <strong class="title-label">Nome</strong>
          <br />
          <span class="label">{{ user.name }}</span>
        </v-col>
        <v-col cols="6" class="my-0">
          <strong class="title-label">CPF</strong>
          <br />
          <span class="label">{{ user.cpf }}</span>
        </v-col>
        <v-col cols="6" class="my-0">
          <strong class="title-label">Data de nascimento</strong>
          <br />
          <span class="label">{{ formatDate(user.dataNascimento) }}</span>
        </v-col>
        <v-col cols="6" class="my-0">
          <strong class="title-label">Número de filhos</strong>
          <br />
          <span class="label">{{ user.numeroFilhos }}</span>
        </v-col>
        <v-col cols="6" class="my-0">
          <strong class="title-label">Valor da renda mensal</strong>
          <br />
          <span class="label">
            {{
              user.valorRenda.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                style: "currency",
                currency: "BRL",
              })
            }}</span
          >
        </v-col>
      </v-row>
    </div>

    <span class="main-subtitle">Sua proteção escolhida:</span>

    <SelectedOption
      :number="selectedItem.number"
      :covers="selectedItem.covers"
      :key="selectedItem.number"
      :result="user"
      :socio="socio"
    />

    <div class="my-6 mr-2 d-flex justify-end align-center">
      <v-btn
        :color="$vuetify.theme.primary || 'primary'"
        style="color: var(--custom-white-second-color) !important"
        elevation="0"
        height="44"
        width="161"
        @click="submit"
        :loading="loading"
      >
        <strong> Preencher proposta </strong>
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
.main-title {
  font-size: 31px;
  line-height: 36px;
  letter-spacing: 0.15px;
  color: #39424e;
}

.main-subtitle {
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.15px;
  color: #39424e;
}

.user-infos {
  background: #ffffff;
  border: 1px solid #00c7ba;
  box-sizing: border-box;
  border-radius: 6px;
}

.title-label {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: #39424e;
}

.label {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: #39424e;
}

.field {
  border: 1px solid #00c7ba;
  box-sizing: border-box;
  border-radius: 6px;
}
</style>

<script>
import SelectedOption from "./selectedOption.vue";
import moment from "moment";
import ApiService from "../../../../services/ApiService";

export default {
  name: "Final",

  props: {
    selectedItem: Object,
    user: Object,
    socio: Object,
  },

  data: () => ({
    loading: false,
    apiService: new ApiService(),
    jobOptions: [],
    retireeOptions: [
      {
        text: "Não",
        value: "nao",
      },
      {
        text: "Aposentado por Tempo de Serviço/Idade",
        value: "portempo",
      },
      {
        text: "Aposentado por Invalidez por Doença",
        value: "invalidezpordoenca",
      },
      {
        text: "Aposentado por Invalidez por Acidente",
        value: "invalidezporacidente",
      },
    ],
    genders: [
      {
        text: "Masculino",
        value: 0,
      },
      {
        text: "Feminino",
        value: 1,
      },
    ],
  }),

  components: {
    SelectedOption,
  },

  methods: {
    submit() {
      this.loading = true;
      const model = {
        name: this.user.name,
        cpf: this.user.cpf,
        dataNascimento: this.user.dataNascimento,
        numeroFilhos: this.user.numeroFilhos,
        valorRenda: this.user.valorRenda,
        secures: this.selectedItem.covers.map((x) => x.id).join(","),
      };

      const data = JSON.parse(localStorage.getItem("@GlobusVida:data"));

      const result = {
        ...model,
        ...data,
      };

      localStorage.setItem("@GlobusVida:data", JSON.stringify(result));
      this.$emit("confirm");

      this.loading = false;
    },

    formatDate(date) {
      return moment(date).format("DD/mm/yyyy");
    },

    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
